import { ButtonGroup as MuiButtonGroup } from '@mui/material';

import { ToggleButton } from './ToggleButton';
import { ToggleButtonGroupProps } from './types';

import { Typography } from '../Typography';

export const ToggleButtonGroup = ({
  buttons,
  value,
  onChange,
  label,
  orientation,
  variant,
  disabled,
  fullWidth,
  fitToContent,
}: ToggleButtonGroupProps) => (
  <>
    {label && <Typography paragraph>{label}</Typography>}
    <MuiButtonGroup
      color='primary'
      size='large'
      orientation={orientation}
      variant={variant}
      disabled={disabled}
      sx={[
        fullWidth ? { display: 'flex' } : null,
        fitToContent && !fullWidth ? { width: 'fit-content', maxWidth: '100%' } : null,
      ]}
    >
      {buttons.map((item) => (
        <ToggleButton
          key={typeof item.value === 'string' ? item.value : item.key}
          fitToContent={fitToContent}
          onClick={onChange}
          value={item.value}
          selected={item.value === value}
        >
          {item.title}
        </ToggleButton>
      ))}
    </MuiButtonGroup>
  </>
);
